export default "__VITE_ASSET__DJe8Ayt$__";